import styled from 'styled-components';

export const StyledDownloadButton = styled.button`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 2000;
  background: #1778fb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(23, 120, 251, 0.15);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s, opacity 0.2s;

  &:hover {
    background: #125bb5;
    box-shadow: 0 4px 16px rgba(23, 120, 251, 0.25);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }

  @media print {
    display: none;
  }
`;
